import type { DayView, Task, TaskPriority, TaskType } from './types'

import { api } from '@/lib/api/client'

const base = (ws: string) => `/v1/workspaces/${ws}`

export interface TaskDraft {
  title: string
  description?: string | null
  task_type?: TaskType
  priority?: TaskPriority
  due_at?: string | null
  assigned_to?: string | null
  lead_id?: string | null
  deal_id?: string | null
  customer_id?: string | null
  conversation_id?: string | null
  ticket_id?: string | null
}

export const tasksApi = {
  myDay: (ws: string) => api.get<DayView>(`${base(ws)}/my-day`),

  list: (ws: string, query: Record<string, string | number> = {}) =>
    api.get<Task[]>(`${base(ws)}/tasks`, query),

  create: (ws: string, draft: TaskDraft) => api.post<Task>(`${base(ws)}/tasks`, draft),

  complete: (ws: string, id: string, outcome?: string) =>
    api.post<void>(`${base(ws)}/tasks/${id}/complete`, { outcome: outcome ?? null }),

  dismiss: (ws: string, id: string) => api.delete<void>(`${base(ws)}/tasks/${id}`),

  reschedule: (ws: string, id: string, dueAt: string) =>
    api.patch<void>(`${base(ws)}/tasks/${id}/schedule`, { due_at: dueAt }),

  completeFollowup: (ws: string, id: string, outcome?: string) =>
    api.post<void>(`${base(ws)}/followups/${id}/complete`, {
      outcome: outcome ?? null,
      status: 'completed',
    }),
}
